import { render, staticRenderFns } from "./bizregionItemData.vue?vue&type=template&id=86c76176&scoped=true&"
import script from "./bizregionItemData.vue?vue&type=script&lang=js&"
export * from "./bizregionItemData.vue?vue&type=script&lang=js&"
import style0 from "./bizregionItemData.vue?vue&type=style&index=0&id=86c76176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c76176",
  null
  
)

export default component.exports